import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { IMG } from "../data/images";
import { CheckCircle2, Clock, GraduationCap, Headphones } from "lucide-react";

export default function Rehabilitation() {
  return (
    <>
      <SEO title="Cochlear Implant Rehabilitation & Auditory Verbal Therapy in India" description="Rehabilitation after cochlear implant — auditory verbal therapy (AVT), speech therapy, mapping, family training and long-term outcomes." />
      <section className="bg-gradient-to-br from-[#F0F9FF] via-white to-[#ECFDF5] py-14">
        <div className="hc-container max-w-4xl">
          <h1 className="font-serif text-[2.25rem] md:text-[3rem] font-semibold leading-[1.08] text-slate-900">Rehabilitation matters as much as surgery</h1>
          <p className="mt-5 text-slate-700 text-[1.05rem]">Children typically need 12–24 months of structured auditory verbal therapy after switch-on. Adults benefit from aural rehabilitation too.</p>
        </div>
      </section>

      <section className="hc-container py-12 grid lg:grid-cols-3 gap-5">
        {[
          { icon: Headphones, t: "Mapping (programming)", d: "Several sessions in the first year to fine-tune the processor to the user." },
          { icon: GraduationCap, t: "Auditory Verbal Therapy", d: "Structured therapy with the child + parent + therapist; listening as the primary route to language." },
          { icon: Clock, t: "Long-term follow-up", d: "Annual reviews, processor upgrades, school readiness reviews and lifelong support." },
        ].map((c, i) => { const Ico = c.icon; return (
          <div key={i} className="card-hc">
            <span className="w-12 h-12 rounded-xl bg-[#ECFDF5] flex items-center justify-center text-[#0F766E] mb-4"><Ico size={22} /></span>
            <div className="font-serif text-xl font-semibold text-slate-900">{c.t}</div>
            <p className="mt-2 text-slate-600 text-[15px]">{c.d}</p>
          </div>);
        })}
      </section>

      <section className="bg-slate-50 hc-section">
        <div className="hc-container grid lg:grid-cols-2 gap-12 items-center">
          <img src={IMG.pediatrician} alt="Therapy with child" className="rounded-3xl shadow-md" />
          <div>
            <h2 className="font-serif text-3xl font-semibold text-slate-900 leading-tight">Therapy milestones after CI (children)</h2>
            <ul className="mt-5 space-y-2.5">
              {[
                "Sound awareness — first weeks",
                "Detection of speech sounds — 1–3 months",
                "Discrimination of words — 3–6 months",
                "First spoken words — 6–12 months (varies)",
                "Short phrases — 12–18 months",
                "Conversational speech — 18–36 months",
                "School-ready language — varies, with consistent therapy",
              ].map((s) => <li key={s} className="flex gap-2 text-slate-700"><CheckCircle2 size={18} className="text-[#0F766E] mt-1 shrink-0" />{s}</li>)}
            </ul>
            <Link to="/register" className="btn-primary mt-6">Find rehabilitation support</Link>
          </div>
        </div>
      </section>
    </>
  );
}
